module.exports = __webpack_public_path__ + "static/media/Burnt-Orange_2.6efeada9.jpg";